module.exports = __webpack_public_path__ + "static/media/googlepay.db44fce9.png";